import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  imports: [TranslocoPipe, MatProgressSpinner],
})
export class LoaderComponent implements OnChanges {
  @Input() message!: string;
  content = this.message;

  ngOnChanges(changes: SimpleChanges): void {
    this.content = this.message;
  }
}
